module.exports = __webpack_public_path__ + "img/banner.6765a55c.png";